import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import Image400 from '../../../../public/static/error/400.png';
import Image401 from '../../../../public/static/error/401.png';
import Image403 from '../../../../public/static/error/403.png';
import Image404 from '../../../../public/static/error/404.png';
import Image50x from '../../../../public/static/error/50x.png';
import BaseLayout from '../../common/layouts/BaseLayout';
import StringUtils from '../../utils/StringUtils';
import css from './Error.module.scss';

interface Props {
  className?: string;
  statusCode: number;
}

const ErrorTemplate = ({
  className,
  intl,
  statusCode,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.Error, className);

  return (
    <BaseLayout>
      <div className={classes}>
        <div className={css.Error__Message}>
          <p className={css.Error__SubTitle}>
            {intl.formatMessage({ id: 'errors.title' })}
          </p>
          <p className={css.Error__Title}>{statusCode}</p>
          <p className={css.Error__Text}>
            {StringUtils.nl2br(
              intl.formatMessage({
                id: `errors.message${statusCode}`,
              }),
            )}
          </p>
          <figure className={css.Error__Image}>
            {statusCode === 400 && (
              <img src={Image400} alt={`${statusCode} Error`} />
            )}
            {statusCode === 401 && (
              <img src={Image401} alt={`${statusCode} Error`} />
            )}
            {statusCode === 403 && (
              <img src={Image403} alt={`${statusCode} Error`} />
            )}
            {statusCode === 404 && (
              <img src={Image404} alt={`${statusCode} Error`} />
            )}
            {statusCode >= 500 && (
              <img src={Image50x} alt={`${statusCode} Error`} />
            )}
          </figure>
        </div>
      </div>
    </BaseLayout>
  );
};

export default injectIntl(ErrorTemplate);
